import { useFormikContext } from 'formik';
import InputBase from './InputBase';
import Select, { SingleValue } from 'react-select';
import { getTranslation } from 'dictionary';
import { useUserContext } from 'context/UserContext';

interface Option {
  label: string;
  value: string;
}

interface Props {
  name: string;
  label?: string;
  slim?: boolean;
  options: Option[];
  placeholder?: string;
  helperText?: string | null;
  disabled?: boolean;
}
const InputSelect: React.FC<Props> = ({
  name,
  label,
  options,
  slim,
  placeholder,
  helperText,
  disabled,
}) => {
  const { language } = useUserContext();

  const { setFieldValue, getFieldProps, setFieldTouched } = useFormikContext<{
    [key: string]: string;
  }>();

  const handleChange = (newValue: SingleValue<Option>) => {
    if (newValue?.value) {
      setFieldValue(name, newValue.value);
    }
  };
  const { value } = getFieldProps(name);

  const inputValue = options.find((o) => o.value === value);

  return (
    <InputBase slim={slim} label={label} name={name} helperText={helperText}>
      <Select
        placeholder={
          placeholder || getTranslation('shared', 'SELECT', language)
        }
        value={inputValue}
        options={options}
        name={name}
        onChange={handleChange}
        // TODO: Can we make this disabled style look different?
        isDisabled={disabled}
        className="text-input p-0 disabled:bg-white"
        onBlur={() => setFieldTouched(name)}
      />
    </InputBase>
  );
};

export default InputSelect;
